import { WEBVIEW_EVENT } from 'constants/events';
import { WebviewNavigateDetail } from 'interfaces/bridge.interface';
import { getRouteForFbNavigateScreen } from 'utils/webview-screen.util';
import { resetWebviewReadyState } from 'utils/webviewProtocol';

// Exposes window.fbNavigate so the native shells (Mac shared "A2" WKWebView) can switch
// the embedded SPA between tool screens WITHOUT a full webView.load() — avoiding a
// re-parse/re-boot of the ~5.7MB bundle. It dispatches WEBVIEW_EVENT.NAVIGATE, which the
// router layer turns into a react-router navigation so the active view re-runs its
// per-screen init (token/data re-injection + readiness signal).
//
// Client-side nav does not fire WKNavigationDelegate.didFinish, so after calling
// fbNavigate the Mac re-injects the screen's token via its existing loadAccessTokenFor*
// globals; those handlers are registered once and persist across navigations.
export const exposeFbNavigate = () => {
  window.fbNavigate = (screen: string) => {
    const targetRoute = getRouteForFbNavigateScreen(screen);
    if (!targetRoute) {
      return;
    }

    // Allow the incoming screen to post a fresh terminal readiness signal.
    resetWebviewReadyState();

    const detail: WebviewNavigateDetail = { screen, path: targetRoute };
    window.dispatchEvent(new CustomEvent(WEBVIEW_EVENT.NAVIGATE, { detail }));
  };
};
